import { useContext } from "react"
import { JSONataEditorContext } from "../contexts/JSONataEditorContext"
import { Editor } from "@monaco-editor/react"

export function Bindings() {
    const { bindings, setBindings } = useContext(JSONataEditorContext)
    return (
        <Editor
            theme="vs-light"
            defaultLanguage="javascript"
            value={bindings}
            options={{
                minimap: { enabled: false },
                glyphMargin: false
            }}
            onChange={(value) => { setBindings(value) }}
        />
    )
}